import React from 'react';
import ComponentCreator from '@docusaurus/ComponentCreator';

export default [
  {
    path: '/blog/',
    component: ComponentCreator('/blog/', '5aa'),
    exact: true
  },
  {
    path: '/blog/archive/',
    component: ComponentCreator('/blog/archive/', '1d9'),
    exact: true
  },
  {
    path: '/blog/authors/',
    component: ComponentCreator('/blog/authors/', '347'),
    exact: true
  },
  {
    path: '/blog/event-sourcing-blockchain-reorgs/',
    component: ComponentCreator('/blog/event-sourcing-blockchain-reorgs/', '822'),
    exact: true
  },
  {
    path: '/blog/how-cqrs-and-eventsourcing-work/',
    component: ComponentCreator('/blog/how-cqrs-and-eventsourcing-work/', 'd64'),
    exact: true
  },
  {
    path: '/blog/index-ethereum-events-without-the-graph/',
    component: ComponentCreator('/blog/index-ethereum-events-without-the-graph/', '38b'),
    exact: true
  },
  {
    path: '/blog/introducing-evm-crawler/',
    component: ComponentCreator('/blog/introducing-evm-crawler/', '267'),
    exact: true
  },
  {
    path: '/blog/nestjs-application-launch-modes/',
    component: ComponentCreator('/blog/nestjs-application-launch-modes/', '932'),
    exact: true
  },
  {
    path: '/blog/self-hosted-vs-cloud-blockchain-indexers/',
    component: ComponentCreator('/blog/self-hosted-vs-cloud-blockchain-indexers/', 'b79'),
    exact: true
  },
  {
    path: '/blog/tags/',
    component: ComponentCreator('/blog/tags/', 'e17'),
    exact: true
  },
  {
    path: '/blog/tags/announcement/',
    component: ComponentCreator('/blog/tags/announcement/', 'b57'),
    exact: true
  },
  {
    path: '/blog/tags/architecture/',
    component: ComponentCreator('/blog/tags/architecture/', '577'),
    exact: true
  },
  {
    path: '/blog/tags/backend/',
    component: ComponentCreator('/blog/tags/backend/', '556'),
    exact: true
  },
  {
    path: '/blog/tags/balances/',
    component: ComponentCreator('/blog/tags/balances/', '97d'),
    exact: true
  },
  {
    path: '/blog/tags/bitcoin/',
    component: ComponentCreator('/blog/tags/bitcoin/', '322'),
    exact: true
  },
  {
    path: '/blog/tags/blockchain/',
    component: ComponentCreator('/blog/tags/blockchain/', '6d8'),
    exact: true
  },
  {
    path: '/blog/tags/comparison/',
    component: ComponentCreator('/blog/tags/comparison/', '347'),
    exact: true
  },
  {
    path: '/blog/tags/context/',
    component: ComponentCreator('/blog/tags/context/', 'd7b'),
    exact: true
  },
  {
    path: '/blog/tags/cost/',
    component: ComponentCreator('/blog/tags/cost/', '766'),
    exact: true
  },
  {
    path: '/blog/tags/cqrs/',
    component: ComponentCreator('/blog/tags/cqrs/', '957'),
    exact: true
  },
  {
    path: '/blog/tags/design-patterns/',
    component: ComponentCreator('/blog/tags/design-patterns/', 'd8c'),
    exact: true
  },
  {
    path: '/blog/tags/development/',
    component: ComponentCreator('/blog/tags/development/', '9b5'),
    exact: true
  },
  {
    path: '/blog/tags/easylayer/',
    component: ComponentCreator('/blog/tags/easylayer/', 'c65'),
    exact: true
  },
  {
    path: '/blog/tags/erc-20/',
    component: ComponentCreator('/blog/tags/erc-20/', 'fdd'),
    exact: true
  },
  {
    path: '/blog/tags/ethereum/',
    component: ComponentCreator('/blog/tags/ethereum/', '375'),
    exact: true
  },
  {
    path: '/blog/tags/event-sourcing/',
    component: ComponentCreator('/blog/tags/event-sourcing/', 'e8c'),
    exact: true
  },
  {
    path: '/blog/tags/evm/',
    component: ComponentCreator('/blog/tags/evm/', '598'),
    exact: true
  },
  {
    path: '/blog/tags/http/',
    component: ComponentCreator('/blog/tags/http/', '492'),
    exact: true
  },
  {
    path: '/blog/tags/indexer/',
    component: ComponentCreator('/blog/tags/indexer/', 'e66'),
    exact: true
  },
  {
    path: '/blog/tags/infrastructure/',
    component: ComponentCreator('/blog/tags/infrastructure/', '0af'),
    exact: true
  },
  {
    path: '/blog/tags/launch-modes/',
    component: ComponentCreator('/blog/tags/launch-modes/', 'be6'),
    exact: true
  },
  {
    path: '/blog/tags/microservices/',
    component: ComponentCreator('/blog/tags/microservices/', '502'),
    exact: true
  },
  {
    path: '/blog/tags/nestjs-cqrs/',
    component: ComponentCreator('/blog/tags/nestjs-cqrs/', '745'),
    exact: true
  },
  {
    path: '/blog/tags/nestjs/',
    component: ComponentCreator('/blog/tags/nestjs/', '99f'),
    exact: true
  },
  {
    path: '/blog/tags/nodejs/',
    component: ComponentCreator('/blog/tags/nodejs/', 'a3e'),
    exact: true
  },
  {
    path: '/blog/tags/open-source/',
    component: ComponentCreator('/blog/tags/open-source/', 'a73'),
    exact: true
  },
  {
    path: '/blog/tags/reorg/',
    component: ComponentCreator('/blog/tags/reorg/', '599'),
    exact: true
  },
  {
    path: '/blog/tags/reorganization/',
    component: ComponentCreator('/blog/tags/reorganization/', '4ef'),
    exact: true
  },
  {
    path: '/blog/tags/self-hosted/',
    component: ComponentCreator('/blog/tags/self-hosted/', '3fd'),
    exact: true
  },
  {
    path: '/blog/tags/smart-contracts/',
    component: ComponentCreator('/blog/tags/smart-contracts/', 'cf3'),
    exact: true
  },
  {
    path: '/blog/tags/sqd/',
    component: ComponentCreator('/blog/tags/sqd/', '30a'),
    exact: true
  },
  {
    path: '/blog/tags/tcp/',
    component: ComponentCreator('/blog/tags/tcp/', '99f'),
    exact: true
  },
  {
    path: '/blog/tags/the-graph/',
    component: ComponentCreator('/blog/tags/the-graph/', '151'),
    exact: true
  },
  {
    path: '/blog/tags/transactional/',
    component: ComponentCreator('/blog/tags/transactional/', '1d9'),
    exact: true
  },
  {
    path: '/blog/tags/typescript/',
    component: ComponentCreator('/blog/tags/typescript/', 'b37'),
    exact: true
  },
  {
    path: '/blog/tags/utxo/',
    component: ComponentCreator('/blog/tags/utxo/', 'a05'),
    exact: true
  },
  {
    path: '/blog/tags/wallet/',
    component: ComponentCreator('/blog/tags/wallet/', 'c05'),
    exact: true
  },
  {
    path: '/blog/tags/websocket/',
    component: ComponentCreator('/blog/tags/websocket/', 'e2d'),
    exact: true
  },
  {
    path: '/blog/tags/welcome/',
    component: ComponentCreator('/blog/tags/welcome/', '7d9'),
    exact: true
  },
  {
    path: '/blog/track-bitcoin-wallet-balances/',
    component: ComponentCreator('/blog/track-bitcoin-wallet-balances/', '830'),
    exact: true
  },
  {
    path: '/blog/welcome-bitcoin-crawler-beta-app/',
    component: ComponentCreator('/blog/welcome-bitcoin-crawler-beta-app/', '0bf'),
    exact: true
  },
  {
    path: '/blog/welcome-from-easylayer-team/',
    component: ComponentCreator('/blog/welcome-from-easylayer-team/', '6d4'),
    exact: true
  },
  {
    path: '/enterprise/',
    component: ComponentCreator('/enterprise/', 'd1a'),
    exact: true
  },
  {
    path: '/licenses/',
    component: ComponentCreator('/licenses/', 'da6'),
    exact: true
  },
  {
    path: '/policy/',
    component: ComponentCreator('/policy/', 'f20'),
    exact: true
  },
  {
    path: '/proof/',
    component: ComponentCreator('/proof/', '98f'),
    exact: true
  },
  {
    path: '/security/',
    component: ComponentCreator('/security/', '9a6'),
    exact: true
  },
  {
    path: '/terms/',
    component: ComponentCreator('/terms/', 'f36'),
    exact: true
  },
  {
    path: '/why/',
    component: ComponentCreator('/why/', '9f6'),
    exact: true
  },
  {
    path: '/docs/',
    component: ComponentCreator('/docs/', 'f3d'),
    routes: [
      {
        path: '/docs/',
        component: ComponentCreator('/docs/', 'c07'),
        routes: [
          {
            path: '/docs/',
            component: ComponentCreator('/docs/', 'c0a'),
            routes: [
              {
                path: '/docs/',
                component: ComponentCreator('/docs/', '9eb'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/data-modeling/',
                component: ComponentCreator('/docs/data-modeling/', 'f40'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/event-store/',
                component: ComponentCreator('/docs/event-store/', '996'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/examples/',
                component: ComponentCreator('/docs/examples/', 'e3b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/first-custom-model/',
                component: ComponentCreator('/docs/first-custom-model/', 'd04'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/',
                component: ComponentCreator('/docs/get-started/', '621'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/', '844'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/0.0.2/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/0.0.2/', '06a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.0.10-alpha.0/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.0.10-alpha.0/', 'fb7'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.0.10/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.0.10/', '63a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.0.4/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.0.4/', 'bc3'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.0.5/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.0.5/', '7fd'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.0.6/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.0.6/', '1ab'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.0.7/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.0.7/', '038'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.0.8/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.0.8/', '6e9'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.0.9/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.0.9/', 'aa7'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.1.0/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.1.0/', 'e41'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.1.1-alpha.0/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.1.1-alpha.0/', 'c2a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.1.1/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.1.1/', '9fc'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.1.2-alpha.0/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.1.2-alpha.0/', '916'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.1.2/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.1.2/', '452'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.1.3/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.1.3/', 'fa5'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.2.0/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.2.0/', 'eee'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.2.1/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.2.1/', '0d3'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.3.0/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.3.0/', 'abe'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.3.1/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.3.1/', '26e'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/bitcoin-crawler/v0.4.0/',
                component: ComponentCreator('/docs/get-started/bitcoin-crawler/v0.4.0/', '5a2'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/evm-crawler/',
                component: ComponentCreator('/docs/get-started/evm-crawler/', '4e7'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/evm-crawler/v0.0.2/',
                component: ComponentCreator('/docs/get-started/evm-crawler/v0.0.2/', '6e9'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/evm-crawler/v0.0.3-alpha.0/',
                component: ComponentCreator('/docs/get-started/evm-crawler/v0.0.3-alpha.0/', '48b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/evm-crawler/v0.0.3/',
                component: ComponentCreator('/docs/get-started/evm-crawler/v0.0.3/', '346'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/evm-crawler/v0.1.0/',
                component: ComponentCreator('/docs/get-started/evm-crawler/v0.1.0/', 'aeb'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/transport-sdk/',
                component: ComponentCreator('/docs/get-started/transport-sdk/', 'f2f'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/transport-sdk/v1.0.14/',
                component: ComponentCreator('/docs/get-started/transport-sdk/v1.0.14/', '612'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/transport-sdk/v1.0.15/',
                component: ComponentCreator('/docs/get-started/transport-sdk/v1.0.15/', 'ede'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/transport-sdk/v1.0.16/',
                component: ComponentCreator('/docs/get-started/transport-sdk/v1.0.16/', 'b4a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/transport-sdk/v1.1.0/',
                component: ComponentCreator('/docs/get-started/transport-sdk/v1.1.0/', '0ab'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/transport-sdk/v1.1.1/',
                component: ComponentCreator('/docs/get-started/transport-sdk/v1.1.1/', '84d'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/transport-sdk/v1.2.0/',
                component: ComponentCreator('/docs/get-started/transport-sdk/v1.2.0/', '0f8'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/get-started/transport-sdk/v1.3.0/',
                component: ComponentCreator('/docs/get-started/transport-sdk/v1.3.0/', '753'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/mempool-monitoring/',
                component: ComponentCreator('/docs/mempool-monitoring/', '91b'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/network-providers/',
                component: ComponentCreator('/docs/network-providers/', 'cb0'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/overview/',
                component: ComponentCreator('/docs/overview/', '75c'),
                exact: true
              },
              {
                path: '/docs/quickstart/',
                component: ComponentCreator('/docs/quickstart/', '710'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/system-models/',
                component: ComponentCreator('/docs/system-models/', 'a7a'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/transport-layer/',
                component: ComponentCreator('/docs/transport-layer/', '8db'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/vs-alternatives/',
                component: ComponentCreator('/docs/vs-alternatives/', '237'),
                exact: true,
                sidebar: "docs"
              },
              {
                path: '/docs/when-to-use/',
                component: ComponentCreator('/docs/when-to-use/', '8cb'),
                exact: true,
                sidebar: "docs"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    path: '/',
    component: ComponentCreator('/', 'e5f'),
    exact: true
  },
  {
    path: '*',
    component: ComponentCreator('*'),
  },
];
